import type { PopDiagLogEvent, PopDiagnosticLogLevel } from 'common/types/pop-signaling';
import {
  formatPopDiagLogLineForConsole,
  getPopH264DiagnosticLevel,
  popDiagnostics,
  setPopH264DiagLogObserver,
} from 'utils/poph264/diagnostics';

import { isPopDevToolsEnabled } from '../enabled';
import { popDevTools } from '../pop-devtools';

export const POPH264_DIAGNOSTIC_LEVELS = ['off', 'info', 'debug', 'verbose'] as const;

let installed = false;

const hasPopSignaling = () => !!(window as any)?.electron?.popSignaling;

const getPopH264Message = (event: PopDiagLogEvent, wasSummary: boolean) =>
  wasSummary ? `encoder ${event.encoderId} diagnostic summary` : formatPopDiagLogLineForConsole(event);

export const installPopH264Tap = () => {
  if (installed || !isPopDevToolsEnabled() || !hasPopSignaling()) return;
  installed = true;

  setPopH264DiagLogObserver((event, { level, wasSummary }) => {
    popDevTools.record({
      channel: 'poph264',
      level: 'info',
      message: getPopH264Message(event, wasSummary),
      data: {
        encoderId: event.encoderId,
        diagnosticLevel: level,
        message: event.message,
        wasSummary,
      },
      streamKey: wasSummary ? `poph264:encoder:${event.encoderId}:summary` : undefined,
    });
  });
};

export const setPopH264DiagnosticLevel = (level: PopDiagnosticLogLevel) => {
  if (!isPopDevToolsEnabled()) return;
  popDiagnostics(level);
  popDevTools.record({
    channel: 'poph264',
    level: level === 'off' ? 'info' : 'warn',
    message: `PopH264 diagnostics ${level}`,
    data: { level },
    isMarker: true,
  });
};

export const getPopDevToolsPopH264DiagnosticLevel = () => getPopH264DiagnosticLevel();

export const uninstallPopH264TapForTests = () => {
  installed = false;
  setPopH264DiagLogObserver(undefined);
};
